import noUiSlider from "nouislider";
import "./modules/common";
import "./modules/viewed";
import "./modules/Category";
import "./modules/catalog-text";
import "./modules/product-card-alignment";
import cart from "./modules/cart";

const FILTER_VISIBLE_OPTIONS = 5;

const initFilterOptionList = (list) => {
  const options = Array.from(list.children).filter((item) =>
    item.classList.contains("checkbox")
  );
  if (options.length <= FILTER_VISIBLE_OPTIONS) return;

  const fieldset = list.closest(".filter__fieldset");
  const searchInput = fieldset?.querySelector('input[name="vendor_query"]');
  const form = list.closest("form");
  const moreButton = document.createElement("button");
  let expanded = false;

  moreButton.type = "button";
  moreButton.className = "filter__more";
  list.insertAdjacentElement("afterend", moreButton);

  const render = () => {
    const searching = Boolean(searchInput?.value.trim());

    options.forEach((option, index) => {
      const input = option.querySelector("input");
      const shouldHide =
        !expanded &&
        !searching &&
        index >= FILTER_VISIBLE_OPTIONS &&
        !input?.checked;

      option.classList.toggle("filter__option--hidden", shouldHide);
    });

    moreButton.hidden = searching;
    moreButton.textContent = expanded ? "Свернуть" : "Показать все";
    moreButton.setAttribute("aria-expanded", String(expanded));
  };

  moreButton.addEventListener("click", () => {
    expanded = !expanded;
    render();
  });
  searchInput?.addEventListener("input", render);
  list.addEventListener("change", render);
  form?.addEventListener("reset", () => {
    setTimeout(() => {
      expanded = false;
      render();
    });
  });

  render();
};

document
  .querySelectorAll(".filter__container, .filter__scroll")
  .forEach(initFilterOptionList);

const hasHiddenInnerCats = (items) => {
  return Array.from(items.querySelectorAll(".inner-cats__item")).some((item) => {
    return window.getComputedStyle(item).display === "none";
  });
};

document.querySelectorAll(".inner-cats__items").forEach((items) => {
  const button = items.querySelector(".inner-cats__more");
  if (button && !hasHiddenInnerCats(items)) {
    button.hidden = true;
  }
});

document.addEventListener("click", (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const button = target.closest(".inner-cats__more");
  if (!button) return;

  event.preventDefault();
  const items = button.closest(".inner-cats__items");
  items?.classList.add("_all");
  button.hidden = true;
});

/**
 * Nouislider (бегунки в форме фильтра каталога)
 */
document.querySelectorAll(".range").forEach(function (rangeElement) {
  // минимальное и максимальное значения, шаг
  let rangeMin = parseInt(
    rangeElement.querySelector(".range__slider").dataset.min
  );
  let rangeMax = parseInt(
    rangeElement.querySelector(".range__slider").dataset.max
  );
  let rangeStep = parseInt(
    rangeElement.querySelector(".range__slider").dataset.step
  );
  if (!rangeStep) rangeStep = 1;

  // значение первого бегунка
  let rangeFrom = parseInt(rangeElement.querySelector(".range__from").value);
  if (!rangeFrom) rangeFrom = rangeMin;

  // значение второго бегунка
  let rangeTo = parseInt(rangeElement.querySelector(".range__to").value);
  if (!rangeTo) rangeTo = rangeMax;

  // инициализация
  const rangeSlider = rangeElement.querySelector(".range__slider");
  let timer = null;
  let isFirstUpdate = 0;
  let resetting = false;

  noUiSlider.create(rangeSlider, {
    start: [rangeFrom, rangeTo],
    connect: true,
    range: {
      min: rangeMin,
      max: rangeMax,
    },
    step: rangeStep,
  });

  // поля с начальным [0] и конечным [1] значениями
  const rangeInputs = [
    rangeElement.querySelector(".range__from"),
    rangeElement.querySelector(".range__to"),
  ];

  // если обновляется бегунок
  rangeSlider.noUiSlider.on("update", (values, handle) => {
    rangeInputs[handle].value =
      new Intl.NumberFormat().format(Math.round(values[handle])) ;
    if (resetting) return;
    if (isFirstUpdate < 2) {
      isFirstUpdate++;
      return; // Прерываем выполнение функции, чтобы не запускать событие при первом обновлении
    }
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }

    timer = setTimeout(() => {
      const event = new Event("change", { bubbles: true });
      rangeInputs[handle].dispatchEvent(event);
    }, 500);
  });

  // если обновляются значения полей
  rangeInputs.forEach((rangeInput, index) => {
    rangeInput.addEventListener("change", () => {
      isFirstUpdate = 1;
      const intValue = rangeInput.value.replace(/[^0-9]/g, "") ||
        String(index === 0 ? rangeMin : rangeMax);
      const setValues = index == 0 ? [intValue, null] : [null, intValue];
      rangeSlider.noUiSlider.set(setValues);
    });
  });

  rangeElement.closest("form")?.addEventListener("reset", () => {
    setTimeout(() => {
      if (timer) clearTimeout(timer);
      timer = null;
      resetting = true;
      rangeSlider.noUiSlider.set([rangeMin, rangeMax]);
      rangeInputs[0].value = new Intl.NumberFormat().format(rangeMin);
      rangeInputs[1].value = new Intl.NumberFormat().format(rangeMax);
      resetting = false;
    });
  });
});
